/* eslint-disable react/no-deprecated, no-console, react/sort-comp, object-shorthand */
import React from 'react';
import { LanguageSupportUtil } from '../../../../utils/language_support_util';
import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';
import TrailTrackResultCard from '../../../../components/cards/TrailTrackResultCard';

const createReactClass = require('create-react-class');

const TracksFeedItem = createReactClass({
  getInitialState: function() {
    return { settingTrackAsVerifiedRoute: null };
  },
  handleTrackSetAsVerifiedRoute: function(data, success, xhr) {
    this.setState({ settingTrackAsVerifiedRoute: 'Success' });
    if (this.props.adminOrPendingOwner) location.reload();
  },
  handleTrackSetAsVerifiedRouteError: function(xhr, status, error) {
    this.setState({ settingTrackAsVerifiedRoute: 'Failed' });
  },
  handleTrackSetAsVerifiedRouteComplete: function(xhr, status) {},
  onSetTrackAsVerifiedRoute: function() {
    if (this.state.settingTrackAsVerifiedRoute === 'Setting') return;
    if (this.props.adminOrPendingOwner && !confirm('Use this recording as the verified route?')) return;
    const url = `/api/alltrails/maps/${this.props.data.id}/verify`;
    this.setState({ settingTrackAsVerifiedRoute: 'Setting' });
    const trailId = this.props.data.trailId !== null ? this.props.data.trailId : this.props.trailId;
    ServerCommunicationUtil.postApiEndpoint(
      url,
      { trail_id: trailId, use_contrib: true },
      this.handleTrackSetAsVerifiedRoute,
      this.handleTrackSetAsVerifiedRouteError,
      this.handleTrackSetAsVerifiedRouteComplete
    );
  },
  onRemoveTrack: function() {
    const url = `/api/alltrails/maps/${this.props.data.id}/remove`;
    ServerCommunicationUtil.postApiEndpoint(url, {}, this.handleTrackRemoved, this.handleTrackRemovedError, this.handleTrackRemovedComplete);
  },
  handleTrackRemoved: function(xhr, status) {
    if (this.props.onTrackDeleted) this.props.onTrackDeleted(this.props.data);
  },
  handleTrackRemovedComplete: function(xhr, status) {},
  handleTrackRemovedError: function(xhr, status, error) {
    console.log(`handleTrackRemovedError error: ${error}`);
  },
  onDeleteTrack: function() {
    if (confirm('Are you sure you want to delete this activity from AllTrails?')) {
      const url = `/api/alltrails/maps/${this.props.data.id}`;
      ServerCommunicationUtil.deleteApiEndpoint(url, {}, this.handleTrackDeleted, this.handleTrackDeletedError, this.handleTrackDeletedComplete);
    }
  },
  handleTrackDeleted: function(xhr, status) {
    if (this.props.onTrackDeleted) this.props.onTrackDeleted(this.props.data);
  },
  handleTrackDeletedComplete: function(xhr, status) {},
  handleTrackDeletedError: function(xhr, status, error) {
    console.log(`handleTrackDeletedError error: ${error}`);
  },
  render() {
    return (
      <TrailTrackResultCard
        adminOrPendingOwner={this.props.adminOrPendingOwner}
        adminUser={this.props.adminUser}
        context={{
          displayMetric: this.props.displayMetric,
          languageRegionCode: this.props.locale
        }}
        idx={this.props.idx}
        key={`track-${this.props.data.id}`}
        onSetTrackAsVerifiedRoute={this.onSetTrackAsVerifiedRoute}
        onRemoveTrack={this.onRemoveTrack}
        onDeleteTrack={this.onDeleteTrack}
        includeTrailName={this.props.includeTrailName}
        track={this.props.data}
        userId={this.props.userId}
      />
    );
  }
});

TracksFeedItem.defaultProps = {
  visible: true
};

export { TracksFeedItem };
/* eslint-enable react/no-deprecated, no-console, react/sort-comp, object-shorthand */
